import { styled } from '@linaria/react';
import { fonts, primitives, semantic, space } from '../../theme/tokens';
import { Badge } from '../../components/Badge';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const PromotionBadge = styled(Badge)`
  align-self: flex-end;
`;

export const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
`;

export const Spacer = styled.div`
  height: ${space['space-800']};
`;

export const Title = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.tight};
`;

export const CategoryLabel = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  margin: ${space['space-400']} 0 0;
`;

export const DescriptionSection = styled.div`
  margin-top: ${space['space-400']};
`;

export const TermsSection = styled.div`
  margin-top: ${space['space-400']};
`;

export const NotificationSection = styled.div`
  margin-top: ${space['space-600']};
`;
